import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { Locale } from '../../locales/translations';
import { NewUserData, PartnerPermissions } from '../../models/User';
import { Coords } from './batches/map';


type UserContext = {
    isAuthenticated: boolean;
    isAdmin: boolean;
    name: string | null;
    viewAsPartner: boolean;
    locale: Locale;
    partnerPermissions: PartnerPermissions | null;
    loading: boolean;
    secretLoading: boolean;
    error: string | null;
    secret: string | null;
    email: string | null;
    location: Coords | null;
};

const initialState: UserContext = {
    isAuthenticated: false,
    isAdmin: false,
    viewAsPartner: false,
    locale: Locale.FRENCH,
    partnerPermissions: null,
    loading: false,
    secretLoading: false,
    error: null,
    secret: null,
    email: null,
    location: null,
    name: '',
};

const userSlice = createSlice({
    name: 'user',
    initialState: initialState,
    reducers: {
        startLoading: (state) => {
            state.loading = true;
        },
        stopLoading: (state) => {
            state.loading = false;
        },
        startSecretLoading: (state) => {
            state.secretLoading = true;
        },
        stopSecretLoading: (state) => {
            state.secretLoading = false;
        },
        setError: (state, { payload: error }: PayloadAction<string>) => {
            state.loading = false;
            state.secretLoading = false;
            state.error = error;
        },
        resetError: (state) => {
            state.error = null;
        },
        setUser: (state, { payload: data }: PayloadAction<NewUserData>) => {
            state.loading = false;
            state.isAuthenticated = true;
            state.isAdmin = data.isFichaAdmin;
            state.locale = data.locale;
            state.partnerPermissions = data.partnerPermissions;
            state.email = data.email
            state.name = data.name
        },
        setSecret: (state, { payload: secret }: PayloadAction<string>) => {
            state.secretLoading = false;
            state.secret = secret;
        },
        setUserLocation: (state, { payload: location }: PayloadAction<Coords>) => {
            state.location = location;
        },
        clearUser: (state) => {
            state.loading = false;
            state.isAuthenticated = false;
            state.isAdmin = false;
            state.partnerPermissions = null;
        },
    }
});

export const UserActions = userSlice.actions;

const UserReducer = userSlice.reducer;

export default UserReducer;